export default "__VITE_ASSET__CdKl$MMN__"